import { Content } from "./AboutTimePhasing";

export default function Customers() {
  return (
    <div>
      <Content
        heading="Who are our Customers?"
        detail="The timePhasing algorithm is trusted and used by organizations in both private and public sector, engaging in activities from the deep sea to outer space."
      />
    </div>
  );
}
